import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-62e54369"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["src", "alt"];
import { ref } from "vue";
import imgDefault from "@/assets/img/default.webp";
export default /*#__PURE__*/_defineComponent({
  __name: 'img',
  props: ["src", "alt"],
  setup: function setup(__props) {
    var props = __props;
    var isDefault = ref(false);
    var onError = function onError(e) {
      var el = e.target;
      var imgElSrc = el.src;
      if (imgElSrc === imgDefault) {
        return;
      }
      isDefault.value = true;
      el.src = imgDefault;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("img", {
        "class": _normalizeClass(["acl-img", {
          "default": isDefault.value
        }]),
        ref: "img",
        src: props.src,
        alt: props.alt,
        onError: onError
      }, null, 42, _hoisted_1);
    };
  }
});